import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType, FileType } from "@/common/types/common";

export async function fileList(
  account_id: string,
  owner_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/file/${owner_id}/list${queryString}`,
  );
}

export async function fileGet(account_id: string, file_id: string) {
  return await clientAxios.get(`account/${account_id}/file/${file_id}/show`);
}

export async function fileCreate(
  account_id: string,
  owner_id: string,
  payload: {
    type: string;
    file: string;
    extension?: string;
    name?: string;
    page?: number;
    infos?: string;
  },
) {
  return await clientAxios.post(`account/${account_id}/file/create`, {
    ...payload,
    owner_id,
  });
}

export async function fileUpdate(
  account_id: string,
  owner_id: string,
  payload: FileType,
) {
  return await clientAxios.put(
    `account/${account_id}/file/${owner_id}/update`,
    payload,
  );
}

export async function fileDelete(account_id: string, file_id: string) {
  return await clientAxios.del(`account/${account_id}/file/${file_id}/delete`);
}
